"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var styles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '18px'
  },
  menuBarBase: {
    backgroundColor: theme.palette.common.white,
    width: '24px',
    height: '2px',
    borderRadius: '10px',
    transition: '0.6s ease',
    transitionTimingFunction: 'cubic-bezier(0.75, 0, 0.29, 1.01)'
  },
  //Animated Styles
  animatedTopBar: {
    '-webkit-transform': 'translate(0px, 8px) rotate(45deg)',
    transform: 'translate(0px, 8px) rotate(45deg)'
  },
  animatedMidBar: {
    opacity: 0
  },
  animatedBottomBar: {
    '-webkit-transform': 'translate(0px, -8px) rotate(-225deg)',
    transform: 'translate(0px, -8px) rotate(-225deg)'
  }
}), {
  name: 'AnimatedHamburgerMenu'
});
var _default = exports.default = styles;